import { selectUseQueryService } from '@opengov/ogql-client/selectors';
import { EOgqlJobState } from '@opengov/ogql-types';
import { EQueryType } from '@opengov/reporting-types';
import { createSelector } from 'reselect';
import { composeEffects } from '../../../../module';
import { selectReportConfigWithMetadata } from '../../../reportExplorer/selectors/selectReportExplorerState';
import { DataTableStatus } from '../../../reportExplorer/types';
import { selectUseLargeScaleQueryLimit } from '../../flags';
import { runV0Query } from '../../reportConfiguration/effects/queries/runQueries';
import { selectIsInStandardReport } from '../../reportConfiguration/selectors';
import { selectConditional } from '../selectors';
import { conditionalActionCreators } from '../state';
import { showPermissionErrorToast } from '../../helpers/permissionErrorHelper';

export const conditionalEffects = composeEffects('conditional', (compose) => ({
  getConditionalPreviewTableData: compose.statefulPayloadlessEffect(
    createSelector(
      [
        selectReportConfigWithMetadata,
        selectConditional,
        selectUseLargeScaleQueryLimit,
        selectUseQueryService,
        selectIsInStandardReport
      ],
      (
        currentReportConfiguration,
        conditionalColumn,
        useLargeScaleQueryLimit,
        useQueryService,
        isStandardTemplate
      ) => ({
        currentReportConfiguration,
        conditionalColumn,
        useLargeScaleQueryLimit,
        useQueryService,
        isStandardTemplate
      })
    ),
    async ({
      currentReportConfiguration,
      conditionalColumn,
      useLargeScaleQueryLimit,
      useQueryService,
      isStandardTemplate
    }) => {
      conditionalActionCreators.updateConditionalPreviewTableStatus(DataTableStatus.Loading);
      return runV0Query({
        reportId: currentReportConfiguration.reportId,
        queryType: EQueryType.conditionalPreview,
        body: { column: conditionalColumn },
        useLargeScaleQueryLimit,
        useQueryService,
        isStandardTemplate
      })
        .then((result) => {
          if (result.state === EOgqlJobState.finished) {
            conditionalActionCreators.setQueryResult(result);
            conditionalActionCreators.updateConditionalPreviewTableStatus(DataTableStatus.Current);
          }
        })
        .catch(showPermissionErrorToast);
    }
  )
}));
